import { fixContent, stylePrice } from "../../utils";
import { not_available_vertical } from "../../pngs";
import {
  CoalitionProgressBar,
  SingleProductImg,
} from "../CoalitionComplements";
import "./CoalitionCardRewards.scss";

export const CoalitionCardRewards = ({
  id,
  product,
  title,
  used,
  needed,
  availableToRedeem,
  showModal,
  buttonRef,
}) => {
  const ready = availableToRedeem >= 1 || used >= needed;
  const balanceFixed = ready ? ready * needed + used : used;
  const balance = `${stylePrice(balanceFixed)} de ${stylePrice(needed)}`;
  return (
    <div
      className="card-rewards"
      ref={buttonRef}
      onClick={() => showModal(id)}
      onKeyPress={() => showModal(id)}
      role="button"
      tabIndex={0}
    >
      <div className="main">
        <div className="product">
          <SingleProductImg load={product} error={not_available_vertical} />
        </div>
        <div className="title">
          <span>{fixContent(title, 48)}</span>
        </div>
      </div>
      <div className={`footer ${ready ? "success" : ""}`}>
        <div className="half-part left">
          <CoalitionProgressBar current={balanceFixed} max={needed} />
        </div>
        <div
          className="half-part right"
          dangerouslySetInnerHTML={{ __html: balance }}
        />
      </div>
    </div>
  );
};
